import { BeneficialOwnersType } from '../giftcard-ach-service.types';

export const beneficialOwners: BeneficialOwnersType = {
  beneficialOwners: [
    {
      id: null,
      externalId: '8d74a79a-c7c2-4cda-a20c-6c521e49bda4',
      locationId: null,
      firstName: 'Beneficial Owner One',
      lastName: null,
      address: {
        address1: '160 Apex Dr',
        address2: 'address 2',
        address3: null,
        city: 'Marlborough',
        stateProvinceRegion: 'MA',
        country: 'United States of America',
        postalCode: '01752',
      },
      createdDate: '2026-01-14T05:21:34.658Z',
      verificationStatus: 'VERIFIED',
      documents: [
        {
          id: 'ec54be16-eaba-4ced-9306-f3e2f6cc7262',
          status: 'REVIEWED',
          type: 'LICENSE',
          created: '2026-05-27T09:36:12Z',
          failureReason: null,
          allFailureReasons: null,
        },
      ],
    },
  ],
};
